<template lang="pug">
app-page(v-app-scroll="handleScroll" :fabItems="fabItems" title="Управление категориями" :loading="loading" @search="text => (search = text.toLowerCase())")
  app-toolbar(:title="'Категории'") 
    app-toolbar-item.ml-2(label="Показать" :items="filterItems" key-name="title" min-width="120" @select="filterBy") {{ currentFilter }}
    app-toolbar-item.ml-2(label="Сортировать" :items="sorterItems" key-name="title" min-width="120" @select="sortBy") {{ currentSort }}

  .text-right
    v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>
    v-chip.ma-2(v-if="selectedFilter != 1" color="#757575" text-color="white" small label close @click:close="filterBy(filterItems[1], 1)") Фильтр:&nbsp;<b>{{ currentFilter }}</b>

  app-group-animation(v-if="list.length > 0")
    app-group-item(v-for="c in list" :key="c.id" cols="12")
      app-card(@click.native="moveCategory(c)" data-aos="fade-top")
        app-card-header 
          app-card-title(v-html="uidCat(c)")
        app-card-body
          app-card-title(v-html="titleCat(c)")
          app-card-caption(v-if="c.startDate" style="color: red;") Начало дествия: {{ c.startDate ? $_shortFormatRu(c.startDate) : '' }}
          app-card-caption(v-if="c.endDate" style="color: red;") Срок дествия до: {{ c.endDate ? $_shortFormatRu(c.endDate) : '' }}
          app-card-caption(v-if="c.outdated" style="color: red;") Устаревшая
  div(v-else)
    app-empty-list Список пуст

  app-dialog(v-model="dialog.category" :header="'Карточка категории - ' + form.category.gasCategoryUid" :items="categoryItems")

  app-dialog-confirm(v-model="dialog.categoryDel" @confirm="deleteCategory(form.category.id)")
    app-card-title.mt-5 
      b Вы точно хотите удалить категорию - 
      | {{form.category.title}} ?

  app-dialog(v-model="dialog.categoryEdit" header="Редактирование категории" @confirm="addCategory()" confirmText="Добавить")
    app-text-field(v-model="form.category.gasCategoryUid" label="номер из ГАС") 
    app-text-field(v-model="form.category.title" label="Название") 

  app-dialog-loading(v-model="syncLoading")
</template>

<script>
import { caseService, syncService } from "@/_services";
import { AppDialogConfirm, AppDialogLoading, AppToolbarItemDivider } from '@/components'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { $_app_moment } from "@/common/AppMoment.js"

import moment from 'moment'
moment.locale('ru')

export default {
  mixins: [ $_app_moment ],

  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    [AppDialogLoading.name]: AppDialogLoading,
  },

  data () {
    return {
      dialog: {
        category: false,
        categoryEdit: false,
        categoryDel: false,
      },
      syncLoading: false,
      search: null,
      form: {
        category: {
          id: '',
          gasCategoryUid: '',
          title: ''
        }
      },
      limit: 10,
    }
  },

  mounted () {
    this.$store.commit('setInCategory', true)
    this.$store.dispatch('category/INIT')
  },

  computed: {
    ...mapGetters('category', ['isCategoriesLoaded']),
    ...mapState('category', ['selectedSort', 'selectedFilter', 'categories']),

    sorterItems () {
      return ['по названию', 'по индексу'].map(el => ({ title: el }))
    },

    filterItems () {
      return ['все', 'активные', 'архивные', 'истек срок действия'].map(el => ({ title: el }))
    },

    currentSort () {
      return this.sorterItems[this.selectedSort].title
    },

    currentFilter () {
      return this.filterItems[this.selectedFilter].title
    },


    loading () {
      return !this.isCategoriesLoaded
    },

    list () {
      return this.limit ? this.listCategories.slice(0, this.limit) : this.listCategories
    },

    listCategories () {
      let list = this.categories.list

      switch (this.selectedFilter) {
        case 1: {
          list = list.filter(item => item.outdated == null)
          list = list.filter(item =>  !item.endDate || ( item.endDate && moment(item.endDate).isAfter(moment()) ) )
          break
        }
        case 2: list = list.filter(item => item.outdated != null); break;
        case 3: list = list.filter(item =>  item.endDate && moment(item.endDate).isBefore(moment()) ); break;
      }

      if (this.search) {
        list = list.filter(item => item.gasCategoryUid.toString().toLowerCase().includes(this.search) || item.title.toLowerCase().includes(this.search))
      }

      switch (this.selectedSort) {
        case 1: list.sort((a, b) => a.gasCategoryUid - b.gasCategoryUid || b.id - a.id); break;
        default: list.sort((a, b) => a.title.localeCompare(b.title) || b.id - a.id)
      }
      
      return list
    },

    fabItems () {
      return [
        // AppToolbarItemDivider,
        { icon:'add', title:'Добавить категорию', action: () =>  this.addNewCategory()},
        AppToolbarItemDivider,
        { icon:'sync', title:'Синхронизация категорий', action: () =>  this.syncCategory()},
      ]
    },

    categoryItems () {
      return [
        { title: 'Редактировать', icon: 'edit', action: () => this.categoryEdit() }, 
        { title: 'Удалить', icon: 'delete', action: () => this.categoryDel()}
      ]
    },
  },

  methods: {
    ...mapMutations('category', ['selectSort', 'selectFilter', 'setCategoriesStatus']),

    sortBy(item, index) {
      this.selectSort(index)
    },

    filterBy(item, index) {
      this.selectFilter(index)
    },

    titleCat (cat) {
      if (!this.search || this.search.length == 0 )  return cat.title

      return cat.title.replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    uidCat (cat) {
      if (!this.search || this.search.length == 0 ) return cat.gasCategoryUid

      return cat.gasCategoryUid.toString().replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    categoryEdit() {
      this.dialog.categoryEdit = true
    },
    categoryDel() {
      this.dialog.categoryDel = true
    },

    addNewCategory () {
      this.form.category.id = ''
      this.form.category.title = ''
      this.form.category.gasCategoryUid = ''
      this.dialog.categoryEdit = true
    },

    syncCategory () {
      this.syncLoading = true
      syncService.syncCategories().then(() => {
        this.syncLoading = false
        this.$store.commit('category/setCategoriesStatus', 0)
        this.$store.dispatch('category/LOAD_CATEGORIES')
      })
      .catch(error=>{
        console.log(error)
        this.syncLoading = false
      })
    },

    moveCategory(c) {
      this.form.category = c
      this.dialog.category = true
    },

    addCategory () {
      return caseService.updateCategories(this.form.category).then(() => {
        this.$store.commit('category/setCategoriesStatus', 0)
        this.$store.dispatch('category/LOAD_CATEGORIES')
      })
    },

    deleteCategory (id) {
      caseService.delCategory(id).then(() => {
        this.$store.commit('category/setCategoriesStatus', 0)
        this.$store.dispatch('category/LOAD_CATEGORIES')
      })
    },

    handleScroll: function (evt, el) {
      let bottomOffset = el.scrollHeight - window.scrollY
      if (bottomOffset < 2 * window.innerHeight) {
        this.limit += 6
      }
      return false
    },

    resetList () {
      this.limit = 10
    }
  },

  watch: {
    cases () {
      this.resetList()
    }
  },

  beforeDestroy() {
    this.$store.commit('setInCategory', false)
  }
}
</script>

<style scoped>

</style>


